import * as React from 'react';
import ReactDataSheet from 'react-datasheet';
import * as moment from 'moment';

import { IGridElement } from '../types';
import { FORMAT } from 'src/components/Form/Date';

const INPUT_FORMAT = 'YYYY-MM-DD';

type TextEditorProps = ReactDataSheet.DataEditorProps<IGridElement> & {
  type?: string;
};

class TextEditor extends React.Component<TextEditorProps> {
  handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    let finalValue = value;
    if (this.props.cell.type === 'date') {
      finalValue = moment(value).format(FORMAT);
    }
    this.props.onChange(finalValue);
  };

  render() {
    let value = this.props.value || '';
    if (this.props.cell.type === 'date' && value) {
      value = moment(value, FORMAT).format(INPUT_FORMAT);
    }
    return (
      <input
        className="p-2 w-full outline-none shadow-inner"
        autoFocus={true}
        value={value}
        onChange={this.handleChange}
        onKeyDown={this.props.onKeyDown}
        type={this.props.type || 'text'}
      />
    );
  }
}

export default TextEditor;



// WEBPACK FOOTER //
// ./src/views/LinkCreateBulk/components/TextEditor.tsx